export const handleBFCache = (event: PageTransitionEvent): void => {
  if (event.persisted) {
    // Remove loading states from buttons when returning via browser back/forward
    document.querySelectorAll(".htmx-request").forEach((el) => {
      el.classList.remove("htmx-request");
    });
    document.querySelectorAll(".btn-loading").forEach((el) => {
      el.classList.remove("btn-loading");
    });
  }
};
